import React from "react";
import { Layout } from "antd";
import { Routes, Route } from "react-router-dom";

import Audit from "pages/Audit";
import Report from "pages/Report";
import Reprocess from "pages/Reprocess";
import Generation from "pages/Generation";
import RequestHistory from "pages/RequestHistory";
import AuditList from "pages/Audit/components/AuditList";
import TPlusOneProcessing from "pages/TPlusOneProcessing";
import ReprocessBatchTable from "pages/Reprocess/components/ReprocessBatchTable";
import ReportSettlementTable from "pages/Report/components/ReportSettlementTable";
import GenerationBatchTable from "pages/Generation/components/GenerationBatchTable";
import RequestHistoryTable from "pages/RequestHistory/components/RequestHistoryTable";
import ReprocessEditableTable from "pages/Reprocess/components/ReprocessEditableTable";
import GenerationEditableTable from "pages/Generation/components/GenerationEditableTable";
import TPlusOneProcessingBatchTable from "pages/TPlusOneProcessing/components/TPlusOneProcessingBatchTable";
import TPlusOneProcessingBatchTransactionsTable from "pages/TPlusOneProcessing/components/TPlusOneProcessingBatchTransactionsTable";

const { Content } = Layout;

const RoutersComponent: React.FC = () => {
  return (
    <Content>
      <Routes>
        <Route path="/generation" element={<Generation />}>
          <Route index element={<GenerationBatchTable />} />
          <Route path="edit/:batchId" element={<GenerationEditableTable />} />
        </Route>

        <Route path="/t-plus-one-processing" element={<TPlusOneProcessing />}>
          <Route index element={<TPlusOneProcessingBatchTable />} />
          <Route path=":batchId" element={<TPlusOneProcessingBatchTransactionsTable />} />
        </Route>

        <Route path="/reprocess" element={<Reprocess />}>
          <Route index element={<ReprocessBatchTable />} />
          <Route path="edit/:batchId" element={<ReprocessEditableTable />} />
        </Route>

        <Route path="/request-history" element={<RequestHistory />}>
          <Route index element={<RequestHistoryTable />} />
        </Route>

        <Route path="/report" element={<Report />}>
          <Route index element={<ReportSettlementTable />} />
        </Route>

        <Route path="/audit" element={<Audit />}>
          <Route index element={<AuditList />} />
        </Route>
      </Routes>
    </Content>
  );
};

export default RoutersComponent;
